/**
 * Demo (Boris) email comes from a seeded `demo-integration-*` account — it is
 * NOT a real connected integration, so it can't be disconnected. When the user
 * hides demo data we drop it from the account lists entirely rather than show a
 * Disconnect/Reconnect action that would fail.
 *
 * Mirrors the message-level `isDemoEmail` check in EmailPanel (both key off the
 * `demo-integration` id prefix).
 */
export function isDemoIntegrationId(id: string | null | undefined): boolean {
  return !!id && id.startsWith('demo-integration');
}
